import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ReplaceableTemplateDirective } from '@abp/ng.core';
import { eThemeLeptonXComponents } from '@volosoft/abp.ng.theme.lepton-x';
import {
  IfReplaceableTemplateExistsDirective,
  PageAlertContainerComponent,
} from '@volo/abp.ng.lepton-x.core';
import {
  NavbarComponent,
  NavbarRoutesComponent,
  NavbarRoutesDirective,
  LpxBrandLogoModule,
  LayoutService,
} from '@volo/ngx-lepton-x.core';
import { LpxToolbarContainerModule, SettingsModule } from '@volosoft/ngx-lepton-x/layouts';
import { Observable } from 'rxjs';
@Component({
  selector: 'sgu-application-layout',
  templateUrl: './sgu-application-layout.component.html',
  styleUrls: ['./sgu-application-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    // ABP / replaceable infrastructure
    ReplaceableTemplateDirective,
    IfReplaceableTemplateExistsDirective,
    PageAlertContainerComponent,

    // Routing
    RouterOutlet,

    // LeptonX core navbar components
    NavbarComponent,
    NavbarRoutesComponent,
    NavbarRoutesDirective,

    // LeptonX header / toolbar / settings building blocks
    LpxBrandLogoModule,
    LpxToolbarContainerModule,
    SettingsModule,
    AsyncPipe,
    CommonModule,
  ],
  standalone: true,
})
export class SguApplicationLayoutComponent {
  toolbarKey = eThemeLeptonXComponents.Toolbar;
  navbarKey = eThemeLeptonXComponents.Navbar;
  routesKey = eThemeLeptonXComponents.Routes;
  navItemsKey = eThemeLeptonXComponents.NavItems;
  breadcrumbKey = eThemeLeptonXComponents.Breadcrumb;
  footerKey = eThemeLeptonXComponents.Footer;
  pageAlertContainerKey = eThemeLeptonXComponents.PageAlertContainer;
  mobileNavbarKey = eThemeLeptonXComponents.MobileNavbar;
  // Note: header uses low-level LeptonX components directly (brand logo,
  // toolbar container, settings) instead of replaceable templates.

  containerClass$: Observable<string[]>;
  constructor(private layoutService: LayoutService) {
    this.containerClass$ = this.layoutService.containerClass$;
  }
}
